/**
 * The list of locale codes that the site will claim to support. The user
 * will be able to change the site's displayed language using the locales
 * supported in this list.
 * @type { string[] }
 */
export const SUPPORTED_LANGUAGES = [
    // THESE ARE IN THE TRANSLATIONS SPREADSHEET  
    { code: 'en-US', label: 'US-English' },
    { code: 'en-CA', label: 'Canada-English' },
    { code: 'fr-CA', label: 'Canada-French' },
    { code: 'en-ZA', label: 'SouthAfrica-English' },
    { code: 'it-IT', label: 'Italy-Italian' },
    { code: 'en-GB', label: 'UK-English' },
    { code: 'en-IN', label: 'India-English' },
    { code: 'nl-BE', label: 'Belgium-Dutch' },
    { code: 'fr-BE', label: 'Belgium-French' },
    { code: 'de-BE', label: 'Belgium-German' },
    { code: 'fr-FR', label: 'France-French' },
    { code: 'es-ES', label: 'Spain-Spanish' },
    { code: 'fi-FI', label: 'Finland-Finish' },
    { code: 'nl-NL', label: 'Netherlands-Dutch' },
    { code: 'de-DE', label: 'Germany-German' },
    { code: 'tr-TR', label: 'Turkey-Turkish' },
    { code: 'ms-MY', label: 'Malaysia-Malay' },
    { code: 'en-MY', label: 'Malaysia-English' },
    { code: 'en-AU', label: 'Australia-English' },
    { code: 'pl-PL', label: 'Poland-Polish' },
    { code: 'cs-CZ', label: 'Czech-Czech' },
    { code: 'ro-RO', label: 'Romania-Romanian' },
    { code: 'zh-CN', label: 'Simplified-Chinese' },
    { code: 'zh-TW', label: 'Taiwan Chinese' },
    { code: 'ko-KR', label: 'SouthKorea-Korean' },
    { code: 'he-IL', label: 'Hebrew' },

    // THESE ARE NOT IN THE TRANSLATIONS SPREADSHEET YET  
    { code: 'pt-BR', label: 'Brazil-Portuguese' },
    { code: 'pt-PT', label: 'Portugal-Portuguese' },
    { code: 'hu-HU', label: 'Hungary-Hungarian' },
    { code: 'ru-RU', label: 'Russia-Russian' },
    { code: 'th-TH', label: 'Thailand-Thai' },
    { code: 'zh-HK', label: 'HongKong-Chinese' },
    { code: 'id-ID', label: 'Indonesia-Indonesian' },
    { code: 'ph-PH', label: 'Philippines-Filipino' },
    { code: 'zh-SG', label: 'Singapore-Chinese' },
    { code: 'de-CH', label: 'Switzerland-German' },
    { code: 'de-AT', label: 'Austria-German' },
    { code: 'sv-SE', label: 'Sweden-Swedish' },
    { code: 'da-DK', label: 'Denmark-Danish' },
    { code: 'ko-KR', label: 'SouthKorea-Korean' },
    { code: 'hi-IN', label: 'India-Hindi' }, 
];

/**
 * A mapping of standard locale codes to locale codes supported by Chameleon.
 */
export const LOCALE_CODE_TO_CHAMELEON_LANGUAGE = {
    // '': 'ar', // Arabic (اللغة العربية)
    // '': 'bs', // Bosnian
    // '': 'bg', // Bulgarian
    'zh-HK': 'zh-hk', // Chinese (Hong Kong)
    'zh-TW': 'zh-tw', // Chinese (Taiwan)
    // '': 'zh-AU', // Chinese Simplified (ANZ)
    'zh-CN': 'zh', // Chinese Simplified (简体中文)
    // '': 'zhaAU', // Chinese Traditional (ANZ)
    // '': 'zh_HA', // Chinese Traditional (繁體中文)
    // '': 'hr', // Croatian
    'cs-CZ': 'cs', // Czech (Česky)
    'da-DK': 'da', // Danish
    'nl-NL': 'nl', // Dutch
    'nl-BE': 'nl-be', // Dutch (Belgium)
    'en-US': 'USA', // English - Code changed to 'USA' for HOYA specifically
    'en-AU': 'en-au', // English (ANZ)
    'en-CA': 'en-CA', // English (Canada)
    // '': 'en-HK', // English (Hong Kong)
    'en-IN': 'en-IN', // English (India)
    'en-MY': 'en-MS', // English (Malaysia)
    'en-PH': 'en-PH', // English (Philippines)
    'en-SG': 'en-SG', // English (Singapore)
    'en-ZA': 'en-ZA', // English (South Africa)
    // '': 'USA', // English (USA)
    'en-GB': 'gb', // English UK
    // '': 'et', // Estonian
    'fi-FI': 'fi', // Finnish
    'fr-BE': 'fr-be', // French (Belgium)
    'fr-CA': 'fr_CA', // French (Français Canadien)
    'fr-FR': 'fr', // French (Français)
    // '': 'fr-CH', // French (Switzerland)
    // '': 'ka', // Georgian
    'de-AT': 'de-at', // German (Austria)
    // '': 'de-BE', // German (Belgium)
    'de-DE': 'de', // German (Deutsch)
    'de-CH': 'gsw', // German (Switzerland)
    // '': 'el', // Greek
    'he-IL': 'he', // Hebrew (עברית)
    'hi-IN': 'hi', // Hindi (हिंदी)
    'hu-HU': 'hu', // Hungarian (Magyar)
    // '': 'is', // Icelandic
    'id-ID': 'id', // Indonesian (Bahasa Indonesia)
    'it-IT': 'it', // Italian (Italiano)
    // '': 'it-CH', // Italian (Switzerland)
    // '': 'ja', // Japanese (日本語)
    // '': 'kk', // Kazakh
    'ko-KR': 'ko', // Korean (한국어)
    // '': 'lv', // Latvian
    // '': 'lt', // Lithuanian
    'ms-MY': 'ms', // Malay (Melayu)
    // '': 'cmn', // Mandarin Chinese (官話; 官话)
    // '': 'no', // Norwegian
    'pl-PL': 'pl', // Polish (Język polski)
    'pt-BR': 'pt_BR', // Portuguese Brazil (Português (Brasil))
    'pt-PT': 'pt_PR', // Portuguese Portugal (Português (Portugal))
    'ro-RO': 'ro', // Romanian (Română)
    'ru-RU': 'ru', // Russian (русский)
    // '': 'sr', // Serbian
    // '': 'sk', // Slovak
    'sk-SK': 'sk', // Slovenian
    'sk-sk': 'sk', // Slovenian
    // '': 'es-cl', // Spanish (Chile)
    'es-ES': 'es', // Spanish (español (de España)(Spain),
    'es-CO': 'es-CO',
    // '': 'es_LA', // Spanish (Español)
    // '': 'es-mx', // Spanish (Mexico)
    'sv-SE': 'sv', // Swedish
    'th-TH': 'th', // Thai (ภาษาไทย)
    'tr-TR': 'tr', // Turkish (Türkçe)
    // '': 'uk', // Ukrainian
    // '': 'ur', // Urdu (اردو )
    // '': 'vi', // Vietnamese (Tieáng Vieät)

    'lt-LT': 'lt', // Lithuanian
    'el-GR': 'el', // Greek
};

/**
 * The locale code of the default language to attempt to use for displaying
 * the site's content.
 * @type { string }
 */
export const DEFAULT_LOCALE_CODE = 'en-US';

/**
 * Whether or not the site should rely on local translations or if it should
 * attempt to use external translations first.
 * @type { boolean }
 */
export const ONLY_USE_LOCAL_TRANSLATIONS = true;

/**
 * Whether or not the user (regardless of who they are) is allowed to select
 * the language they'd prefer to view the site in.
 * @type { boolean }
 */
export const ALLOW_LANGUAGE_SELECTION = false;

/**
 * local storage key for preferred locale
 */
export const PREFERRED_LOCALE = 'pref_loc';